import { useQuery } from '@tanstack/react-query';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import {
  getThoughspotUser,
  getThoughtspotMetadata,
  exportThoughtspotMetadata
} from 'Services/Query/Thoughspot';

export const useThoughtspot = ({
  liveboardId
}: { liveboardId?: string } = {}) => {
  const { user: loggedUser } = useAppContext();
  const { data: tsUser } = useQuery(getThoughspotUser(loggedUser.Email));
  const { data: liveboards, isLoading } = useQuery(
    getThoughtspotMetadata({
      body: {
        ...(liveboardId ? { include_details: true } : {}),
        metadata: [
          {
            type: 'LIVEBOARD',
            ...(liveboardId ? { identifier: liveboardId } : {})
          }
        ]
      },
      thoughspotUserAccessToken: tsUser?.token
    })
  );

  const { data: exportedData, isLoading: isExporting } = useQuery({
    ...exportThoughtspotMetadata({
      body: {
        metadata: [{ type: 'LIVEBOARD', identifier: liveboardId }],
        edoc_format: 'JSON',
        export_associated: true
      },
      thoughspotUserAccessToken: tsUser?.token
    }),
    enabled: !!liveboardId
  });

  return {
    user: tsUser,
    liveboard: liveboards?.[0],
    liveboards,
    isLoading,
    exportedData,
    isExporting
  };
};
